import { render, staticRenderFns } from "./DynamicAttributeDefaultWithOptions.vue?vue&type=template&id=60468fc3&"
import script from "./DynamicAttributeDefaultWithOptions.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeDefaultWithOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports